@import 'vars';
@import 'mixins';

$row-height: 40px;
$row-width: 460px;
$actions-width--agent: 0;

.contact {
  display: contents;

  &__body {
    display: flex;
    overflow: hidden;
    border-radius: 6px;
    cursor: inherit;
    width: 100%;
    align-items: center;
    padding-left: 0;
    transition: padding 0.15s ease-in-out;

    &--softphone {
      --dropcap-width: 0;

      transition: padding 0.1s ease-in-out;
    }

    &--agent-tab {
      --actions-width: #{$actions-width--agent};
    }

    &--transfer {
      &:hover {
        cursor: pointer;
        position: relative;
        overflow: visible;
        padding-left: 10px;

        &::before {
          content: '';
          position: absolute;
          top: -10px;
          bottom: -10px;
          border-radius: 8px;
          left: 0;
          background-color: $light-grey;
          width: calc(100% - 20px);
        }
      }

      &--softphone:hover {
        padding-left: 5px;

        &::before {
          top: -5px;
          bottom: -5px;
          width: calc(100% - 15px);
        }
      }
    }
  }

  &__dropcap {
    font-size: $font-size-large;
    user-select: none;
    position: sticky;
    top: 7px;
    background-color: $white;
    display: flex;
    align-items: center;
    height: fit-content;
    align-self: center;
  }

  &__avatar {
    display: flex;
    align-items: center;
  }

  &__details {
    display: flex;
    flex: 1;
    justify-content: center;
    gap: 7px;
    flex-direction: column;
    z-index: 1;
    overflow: hidden;
    margin-left: 10px;

    &__job-title {
      font-size: $font-size-small-softphone;
      margin-bottom: auto;
    }

    &--softphone {
      gap: 2px;

      > * {
        height: 14px;
      }
    }

    &--searching {
      gap: 2px;
    }

    &__info-contact {
      display: flex;
      gap: 5px;
      align-items: center;
      height: 15px;

      &__phone-number {
        font-size: $font-size-small;
        cursor: pointer;
      }

      &__contact-type {
        // The contact type gets cut off with default line height
        line-height: $line-height-small;
      }
    }

    &--small {
      font-size: $font-size-small;
    }

    &__name {
      display: flex;
      gap: 5px;
      align-items: center;
      height: 14px;

      &__text {
        font-size: $font-size-large-softphone;
        max-width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;

        &--softphone {
          font-size: $font-size-small !important;
          font-weight: $font-weight-medium !important;
        }
      }
    }

    // in case of search and no job title is present
    &__name:only-child {
      height: 100%;
    }
  }

  &__actions {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-left: 10px;
    gap: 10px;

    &__in-progress {
      margin-left: 10px;
      display: flex;
      align-items: center;
    }
  }
}

:export {
  rowheight: $row-height;
}
